module.exports = __webpack_public_path__ + "assets/AirbnbCereal-Medium.d0bd7b095c7c3829f6a026da57b82691.woff2";